import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import _pick from 'lodash/pick';
import _omit from 'lodash/omit';
import React from 'react';
import PropTypes from 'prop-types';
import { RefinanceCalculator as RefinanceCalculator$1, RefinanceCalculatorShape } from '@zillow/zrs-cms';

var BlockRefinanceCalculator = function BlockRefinanceCalculator(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  return /*#__PURE__*/React.createElement(RefinanceCalculator$1, _extends({
    defaultValues: _pick(attrs, Object.keys(RefinanceCalculatorShape))
  }, _omit(attrs, Object.keys(RefinanceCalculatorShape)), {
    key: index
  }));
};
BlockRefinanceCalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  attrs: PropTypes.shape(RefinanceCalculatorShape)
} : {};
var RefinanceCalculator = BlockRefinanceCalculator;

export { RefinanceCalculator as default };
